/* CUSTOM_PROJECTASSEMBLY_BY_CLAUDE (Ryan 2026-09-23) — the Projects hub's EQUIPMENT-LIST CARD, in its own asset.
   Lifted out of sections/rep-quote-projects.liquid the same evening it was written: the section was
   8 KB under Shopify's 256 KB template ceiling and the next feature (custom categories and items)
   would not have fitted. The section keeps a two-line shim; everything the card does lives here.
   `window.RepProjList(ctx)` takes the section's closure — { API, esc, showConfirm, showError,
   detailAssets, currentProject() } — and returns { listConfigFor, toggleListCard }. */
(function() {
  'use strict';
  window.RepProjList = function(ctx) {
    var API = ctx.API, esc = ctx.esc, showConfirm = ctx.showConfirm, showError = ctx.showError, detailAssets = ctx.detailAssets;
    /* ═══════════════════════════════════════════════════════════════════════════════════════
       CUSTOM_PROJECTASSEMBLY_BY_CLAUDE (Ryan 2026-09-23) — THE EQUIPMENT-LIST PAGE UNDER A PLAN
       ═══════════════════════════════════════════════════════════════════════════════════════
       *"We need the option, on floor plans added to projects, to add a page under each floor plan
       which returns a list of everything in the floor plan as far as equipment, flooring, turf, and
       platforms go … a toggle to list everything as 'Detailed' or 'High-Level' … a 3rd toggle for
       'Custom' … the button to trigger one of these lists should be on the row that reads 'Version
       A 9/20/2026 Latest' … clicking it could expand the child card down lower (smoothly with clean
       UX/UI) and have all the settings in there to edit and get a preview of the list."*

       The MODEL is the worker's (lib/plan-list.js): GET /design-items/{designId} answers the
       plan's saved items plus the Detailed and High-Level groupings built by the same function the
       packet prints from, so this preview and the PDF cannot disagree. Custom is a layer of the
       rep's words over one of those two groupings, keyed by line / group, saved on the project as
       `listPages[assetKey]` and sent with Generate like the headings are. Quantities are never
       editable. Editing any word flips the toggle to Custom; switching back warns before it drops
       the words. The page heading defaults to "<plan heading> List". */
    var listCardState = {};   // assetKey -> { cfg, items, designId, saveTimer }
    function listConfigFor(key) {
      var lp = ctx.currentProject() && ctx.currentProject().listPages;
      return (lp && typeof lp === 'object' && lp[key] && typeof lp[key] === 'object') ? lp[key] : null;
    }
    function listDefaultHeading(key) {
      var card = detailAssets.querySelector('.rep-proj__asset-card[data-asset-key="' + key + '"]');
      var inp = card ? card.querySelector('.rep-proj__asset-heading') : null;
      var ph = inp ? inp.value.replace(/\s+/g, ' ').trim() : '';
      return ph ? (ph + ' List').slice(0, 60) : 'Equipment List';
    }
    function saveListConfig(key, cfg, immediate) {
      if (!ctx.currentProject()) return;
      if (!ctx.currentProject().listPages || typeof ctx.currentProject().listPages !== 'object') ctx.currentProject().listPages = {};
      if (cfg) ctx.currentProject().listPages[key] = cfg; else delete ctx.currentProject().listPages[key];
      var st = listCardState[key] || (listCardState[key] = {});
      clearTimeout(st.saveTimer);
      var body = { id: ctx.currentProject().id, listPages: {} };
      body.listPages[key] = cfg || null;
      var send = function() { API.post('/project-update', body).catch(function(err) { showError('List page not saved: ' + (err.message || 'network')); }); };
      if (immediate) send(); else st.saveTimer = setTimeout(send, 450);
    }
    function relabelListPills(key) {
      var card = detailAssets.querySelector('.rep-proj__asset-card[data-asset-key="' + key + '"]');
      if (!card) return;
      var has = !!listConfigFor(key);
      card.querySelectorAll('.rep-proj__ver-list').forEach(function(b) { b.textContent = has ? 'Edit List' : 'Add List'; b.classList.toggle('rep-proj__ver-list--on', has); });
    }
    /* ── CUSTOM CATEGORIES AND ITEMS (Ryan 2026-09-23) ──
       *"a button to add a custom category to the list, regardless of whether it's set to Detailed,
       High-level, or custom … also, add individual items to existing lists … highlight it in a
       different color, so even as we switch between High-Level to Detailed to Custom we can clearly
       see the custom items/categories that we added."*
       Stored on the same config: `extraGroups` (a custom category: its own title and lines) and
       `extraLines` (an item added under an existing group, carrying the brand it was added under
       and/or the category, so it lands in the right group in BOTH bases). Quantities are free text.
       Retyping these never flips the mode — they are additions, not rewording. The worker's
       buildPlanList (lib/plan-list.js) places them the same way for the PDF. */
    function newId() { return 'x' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }
    /* ── "@" PICKS A PRODUCT FROM THE WEBSITE (Ryan 2026-09-23) ──
       *"When adding an item to a list, can you make it so I can type "@" and choose an item from the
       website? Formatted text wise the same as actual items imported onto the list via the GLD."*
       The same product index the email composer's "@" uses (GET /product-mention-index: t title,
       h handle, v vendor, u storefront URL). A picked product rides on the item as `product` and the
       item then formats per mode exactly like a designer item — Detailed keeps the name up to " - ",
       High-Level drops the brand and model code — and links when the link box is on. Typing over the
       name afterwards keeps the product but prints the rep's words instead. The two name rules are the
       worker's (lib/plan-list.js detailedName / highLevelName), restated here for the preview. */
    var mentionIndex = null, mentionLoading = null;
    function loadMentionIndex() {
      if (mentionIndex) return Promise.resolve(mentionIndex);
      if (!mentionLoading) mentionLoading = API.get('/product-mention-index').then(function(d) { mentionIndex = (d && d.products) || []; return mentionIndex; }).catch(function() { mentionLoading = null; return []; });
      return mentionLoading;
    }
    function matchProducts(q) {
      var s = (q || '').toLowerCase().trim();
      var list = mentionIndex || [];
      if (!s) return list.slice(0, 8);
      var starts = [], contains = [];
      for (var i = 0; i < list.length && (starts.length + contains.length) < 40; i++) {
        var p = list[i]; var t = (p.t || '').toLowerCase(), v = (p.v || '').toLowerCase();
        if (t.indexOf(s) === 0) starts.push(p); else if (t.indexOf(s) !== -1 || v.indexOf(s) !== -1) contains.push(p);
      }
      return starts.concat(contains).slice(0, 8);
    }
    function detailedName(title) {
      var t = String(title || '').replace(/\s+/g, ' ').trim();
      t = t.split(/\s+[-\u2013\u2014]\s+/)[0].trim();
      return t.split(/\s+\|\s+/)[0].trim();
    }
    function highLevelName(title, vendor) {
      var t = detailedName(title), v = String(vendor || '').trim();
      if (v && t.toLowerCase().indexOf(v.toLowerCase()) === 0) t = t.slice(v.length).trim();
      t = t.replace(/^(legend|ecore|spirit|hyperice|cascade|renegade|tko|defiant)\b\s*(fitness|athletic|strength)?\s*/i, function(m) { return t.length > m.length ? '' : m; });
      var toks = t.split(' '), i = 0;
      while (i < toks.length - 1) { var tok = toks[i]; if (!(/\d/.test(tok) || (/^[A-Z][A-Z0-9\-\/]{1,6}$/.test(tok) && tok.length <= 7))) break; i++; }
      var out = toks.slice(i).join(' ').replace(/^[\-\u2013\u2014:,]\s*/, '').trim();
      return (out && /[A-Za-z]{3,}/.test(out)) ? out : detailedName(title);
    }
    function extraDisplayText(x, base) {
      if (x.text) return x.text;
      var p = x.product;
      if (!p) return '';
      return base === 'detailed' ? detailedName(p.title) : highLevelName(p.title, p.vendor);
    }
    function attachMention(span, onPick) {
      var menu = null, items = [], active = -1;
      function close() { if (menu) menu.remove(); menu = null; items = []; active = -1; }
      function query() { var t = span.textContent || ''; var at = t.lastIndexOf('@'); return at < 0 ? null : t.slice(at + 1); }
      function paint() { if (!menu) return; menu.querySelectorAll('.rep-proj__list-mention-row').forEach(function(r, i) { r.classList.toggle('rep-proj__list-mention-row--active', i === active); }); }
      function render() {
        if (!items.length) { close(); return; }
        if (!menu) { menu = document.createElement('div'); menu.className = 'rep-proj__list-mention'; document.body.appendChild(menu); }
        var r = span.getBoundingClientRect();
        menu.style.left = r.left + 'px'; menu.style.top = (r.bottom + 4) + 'px'; menu.style.minWidth = Math.max(260, r.width) + 'px';
        menu.innerHTML = items.map(function(p) {
          return '<div class="rep-proj__list-mention-row"><span class="rep-proj__list-mention-title">' + esc(detailedName(p.t)) + '</span>' + (p.v ? '<span class="rep-proj__list-mention-vendor">' + esc(p.v) + '</span>' : '') + '</div>';
        }).join('');
        menu.querySelectorAll('.rep-proj__list-mention-row').forEach(function(row, i) {
          row.addEventListener('mousedown', function(e) { e.preventDefault(); pick(items[i]); });
        });
        active = 0; paint();
      }
      function pick(p) { close(); onPick(p); }
      span.addEventListener('input', function() {
        var q = query();
        if (q === null) { close(); return; }
        loadMentionIndex().then(function() { if (query() === null) return; items = matchProducts(query()); render(); });
      });
      span.addEventListener('keydown', function(e) {
        if (!menu) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); e.stopImmediatePropagation(); active = (active + 1) % items.length; paint(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); e.stopImmediatePropagation(); active = (active - 1 + items.length) % items.length; paint(); }
        else if (e.key === 'Enter' || e.key === 'Tab') { e.preventDefault(); e.stopImmediatePropagation(); pick(items[active >= 0 ? active : 0]); }
        else if (e.key === 'Escape') { e.stopImmediatePropagation(); close(); }
      }, true);
      span.addEventListener('blur', function() { setTimeout(close, 150); });
    }
    function guessCategory(text) {
      var t = String(text || '');
      if (/\b(treadmill|elliptical|bike|cycle|rower|rowing|climber|stair|stepper|ski ?erg|airdyne|assault|cardio|cross ?trainer|recumbent|upright|arc trainer)\b/i.test(t)) return 'Cardio Equipment';
      if (/\b(storage|rack tree|tree|holder|shelf|shelving|cart|caddy|bin|organizer|hanger|wall mount|accessor)/i.test(t)) return 'Storage & Accessories';
      return 'Strength Equipment';
    }
    function findExtra(cfg, id) {
      var i, j;
      var xl = cfg.extraLines || [];
      for (i = 0; i < xl.length; i++) if (xl[i].id === id) return { arr: xl, idx: i, item: xl[i] };
      var xg = cfg.extraGroups || [];
      for (i = 0; i < xg.length; i++) for (j = 0; j < (xg[i].lines || []).length; j++) if (xg[i].lines[j].id === id) return { arr: xg[i].lines, idx: j, item: xg[i].lines[j], group: xg[i] };
      return null;
    }
    function addExtraLine(key, where) {
      var st = listCardState[key]; if (!st) return;
      var item = { id: newId(), qty: '1', text: '' };
      if (where.xg) {
        var g = (st.cfg.extraGroups || []).filter(function(x) { return x.id === where.xg; })[0];
        if (!g) return;
        g.lines = g.lines || []; g.lines.push(item);
      } else {
        if (where.brand) item.brand = where.brand;
        if (where.category) item.category = where.category;
        st.cfg.extraLines = st.cfg.extraLines || []; st.cfg.extraLines.push(item);
      }
      st.showAll = true;
      saveListConfig(key, st.cfg, true);
      renderListPreview(key, item.id);
    }
    function addExtraGroup(key) {
      var st = listCardState[key]; if (!st) return;
      var g = { id: newId(), title: 'New category', lines: [{ id: newId(), qty: '1', text: '' }] };
      st.cfg.extraGroups = st.cfg.extraGroups || []; st.cfg.extraGroups.push(g);
      st.showAll = true;
      saveListConfig(key, st.cfg, true);
      renderListPreview(key, g.lines[0].id, g.id);
    }
    function removeExtra(key, id) {
      var st = listCardState[key]; if (!st) return;
      var f = findExtra(st.cfg, id); if (!f) return;
      f.arr.splice(f.idx, 1);
      saveListConfig(key, st.cfg, true);
      renderListPreview(key);
    }
    /* Designer items taken off the list: hidden by key, restorable, never touched on the plan. */
    function hideStock(key, lineKey) {
      var st = listCardState[key]; if (!st) return;
      st.cfg.hidden = st.cfg.hidden || [];
      if (st.cfg.hidden.indexOf(lineKey) < 0) st.cfg.hidden.push(lineKey);
      saveListConfig(key, st.cfg, true);
      renderListPreview(key);
    }
    function restoreStock(key, lineKey) {
      var st = listCardState[key]; if (!st) return;
      st.cfg.hidden = (st.cfg.hidden || []).filter(function(k) { return k !== lineKey; });
      if (!st.cfg.hidden.length) { delete st.cfg.hidden; st.showRemoved = false; }
      saveListConfig(key, st.cfg, true);
      renderListPreview(key);
    }
    function removeExtraGroup(key, gid) {
      var st = listCardState[key]; if (!st) return;
      st.cfg.extraGroups = (st.cfg.extraGroups || []).filter(function(x) { return x.id !== gid; });
      saveListConfig(key, st.cfg, true);
      renderListPreview(key);
    }
    function customHasText(cfg) {
      var c = cfg && cfg.custom;
      if (!c) return false;
      var n = 0;
      Object.keys(c.headers || {}).forEach(function(k) { if (c.headers[k]) n++; });
      Object.keys(c.names || {}).forEach(function(k) { if (c.names[k]) n++; });
      return n > 0;
    }
    /* Open / close the card under the plan's version rows. `designId` is the version the pill sat
       on; the preview reads THAT version's items (the packet reads each selected version's own). */
    function toggleListCard(asset, key, designId, latestId) {
      var card = detailAssets.querySelector('.rep-proj__asset-card[data-asset-key="' + key + '"]');
      if (!card) return;
      var existing = card.querySelector('.rep-proj__list-card');
      if (existing) {
        var open = existing.classList.contains('rep-proj__list-card--open');
        if (open && existing.dataset.designId === (designId || '')) { collapseListCard(existing); return; }
        if (open) { existing.dataset.designId = designId || ''; loadListItems(key, designId || latestId); return; }
        expandListCard(existing); existing.dataset.designId = designId || ''; loadListItems(key, designId || latestId); return;
      }
      var st = listCardState[key] || (listCardState[key] = {});
      st.cfg = listConfigFor(key) || { enabled: true, mode: 'detailed', linkProducts: false };
      if (!listConfigFor(key)) saveListConfig(key, st.cfg, true); // "Add List" IS the add
      relabelListPills(key);
      var el = buildListCard(asset, key);
      el.dataset.designId = designId || '';
      card.appendChild(el);
      requestAnimationFrame(function() { expandListCard(el); });
      loadListItems(key, designId || latestId);
    }
    function expandListCard(el) {
      var inner = el.querySelector('.rep-proj__list-inner');
      el.classList.add('rep-proj__list-card--open');
      el.style.maxHeight = (inner.scrollHeight + 24) + 'px';
      var done = function(ev) { if (ev.propertyName !== 'max-height') return; el.removeEventListener('transitionend', done); if (el.classList.contains('rep-proj__list-card--open')) el.style.maxHeight = 'none'; };
      el.addEventListener('transitionend', done);
    }
    function collapseListCard(el) {
      var inner = el.querySelector('.rep-proj__list-inner');
      el.style.maxHeight = (inner.scrollHeight + 24) + 'px';
      // Two frames: the browser needs a fixed height to transition FROM, not 'none'.
      requestAnimationFrame(function() { requestAnimationFrame(function() { el.classList.remove('rep-proj__list-card--open'); el.style.maxHeight = '0px'; }); });
    }
    function buildListCard(asset, key) {
      var st = listCardState[key];
      var el = document.createElement('div');
      el.className = 'rep-proj__list-card';
      el.innerHTML =
        '<div class="rep-proj__list-inner">' +
          '<div class="rep-proj__list-head">' +
            '<span class="rep-proj__list-title">Equipment list page</span>' +
            '<label class="rep-proj__list-include"><input type="checkbox" class="rep-proj__list-enabled"' + (st.cfg.enabled !== false ? ' checked' : '') + '> Include in proposal</label>' +
            '<span class="rep-proj__asset-spacer"></span>' +
            '<input type="text" class="rep-proj__asset-heading rep-proj__list-heading" maxlength="60" title="The heading printed at the top of the list page. Defaults to the plan heading plus &quot;List&quot;." value="' + esc(st.cfg.heading || '') + '">' +
            '<button type="button" class="rep-proj__list-remove" title="Remove the list page from this plan">Remove</button>' +
          '</div>' +
          '<div class="rep-proj__list-controls">' +
            '<span class="rep-proj__view-toggle rep-proj__list-modes">' +
              '<button type="button" class="rep-proj__view-btn" data-mode="detailed">Detailed</button>' +
              '<button type="button" class="rep-proj__view-btn" data-mode="highlevel">High-Level</button>' +
              '<button type="button" class="rep-proj__view-btn" data-mode="custom">Custom</button>' +
            '</span>' +
            '<label class="rep-proj__packet-toggle rep-proj__list-linklabel"><input type="checkbox" class="rep-proj__list-link"' + (st.cfg.linkProducts ? ' checked' : '') + '> Link items to the website</label>' +
            '<span class="rep-proj__list-hint">Click any name or header to retype it</span>' +
            '<button type="button" class="rep-proj__ver-open rep-proj__list-addcat" title="Add a category of your own for items we do not list online yet">+ Add category</button>' +
          '</div>' +
          '<div class="rep-proj__list-preview"><div class="rep-proj__list-loading"><div class="rep-quote-spinner" style="display:inline-block;width:16px;height:16px;"></div> Reading the plan…</div></div>' +
          '<div class="rep-proj__list-note"></div>' +
        '</div>';
      var headingIn = el.querySelector('.rep-proj__list-heading');
      headingIn.placeholder = listDefaultHeading(key);
      headingIn.addEventListener('keydown', function(e) { if (e.key === 'Enter') { e.preventDefault(); headingIn.blur(); } });
      headingIn.addEventListener('change', function() {
        var val = headingIn.value.replace(/\s+/g, ' ').trim().slice(0, 60);
        headingIn.value = val;
        if (val) st.cfg.heading = val; else delete st.cfg.heading;
        saveListConfig(key, st.cfg);
      });
      el.querySelector('.rep-proj__list-enabled').addEventListener('change', function(e) {
        st.cfg.enabled = !!e.target.checked;
        el.classList.toggle('rep-proj__list-card--off', !st.cfg.enabled);
        saveListConfig(key, st.cfg);
      });
      el.classList.toggle('rep-proj__list-card--off', st.cfg.enabled === false);
      el.querySelector('.rep-proj__list-link').addEventListener('change', function(e) {
        st.cfg.linkProducts = !!e.target.checked;
        renderListPreview(key);
        saveListConfig(key, st.cfg);
      });
      el.querySelectorAll('.rep-proj__list-modes .rep-proj__view-btn').forEach(function(btn) {
        btn.addEventListener('click', function() { setListMode(key, btn.dataset.mode); });
      });
      el.querySelector('.rep-proj__list-addcat').addEventListener('click', function() { addExtraGroup(key); });
      el.querySelector('.rep-proj__list-remove').addEventListener('click', function() {
        showConfirm('Remove the list page?', 'The list page under ' + (asset.ref || 'this plan') + ' will be dropped from the proposal, along with any custom wording on it.', 'Remove', async function() {
          saveListConfig(key, null, true);
          delete listCardState[key];
          collapseListCard(el);
          setTimeout(function() { if (el.parentNode) el.parentNode.removeChild(el); }, 400);
          relabelListPills(key);
        });
      });
      syncListModeButtons(el, st.cfg.mode);
      return el;
    }
    function syncListModeButtons(el, mode) {
      el.querySelectorAll('.rep-proj__list-modes .rep-proj__view-btn').forEach(function(b) { b.classList.toggle('rep-proj__view-btn--active', b.dataset.mode === mode); });
      el.querySelector('.rep-proj__list-hint').textContent = mode === 'custom' ? 'Custom wording. Quantities stay as counted.' : 'Click any name or header to retype it';
    }
    function setListMode(key, mode) {
      var st = listCardState[key];
      if (!st || st.cfg.mode === mode) return;
      var card = detailAssets.querySelector('.rep-proj__asset-card[data-asset-key="' + key + '"] .rep-proj__list-card');
      var apply = function() {
        st.cfg.mode = mode;
        if (mode === 'custom') { if (!st.cfg.custom) st.cfg.custom = { base: 'detailed', headers: {}, names: {} }; }
        else delete st.cfg.custom;
        if (card) syncListModeButtons(card, mode);
        renderListPreview(key);
        saveListConfig(key, st.cfg);
      };
      if (st.cfg.mode === 'custom' && customHasText(st.cfg)) {
        var label = mode === 'highlevel' ? 'High-Level' : 'Detailed';
        showConfirm('Drop the custom wording?', 'Switching to ' + label + ' will discard everything you retyped on this list. Quantities are unaffected.', 'Discard', async function() { apply(); });
        return;
      }
      apply();
    }
    async function loadListItems(key, designId) {
      var st = listCardState[key];
      var card = detailAssets.querySelector('.rep-proj__asset-card[data-asset-key="' + key + '"] .rep-proj__list-card');
      if (!st || !card) return;
      var pv = card.querySelector('.rep-proj__list-preview');
      if (!designId) { pv.innerHTML = '<div class="rep-proj__list-empty">This plan has no saved version to read.</div>'; return; }
      try {
        var res = await API.get('/design-items/' + encodeURIComponent(designId));
        st.items = res || null;
      } catch (e) {
        pv.innerHTML = '<div class="rep-proj__list-empty rep-proj__list-empty--error">Could not read the plan: ' + esc(e.message || 'network') + ' <button type="button" class="rep-proj__ver-open rep-proj__list-retry">Retry</button></div>';
        pv.querySelector('.rep-proj__list-retry').addEventListener('click', function() { loadListItems(key, designId); });
        return;
      }
      renderListPreview(key);
      if (card.classList.contains('rep-proj__list-card--open') && card.style.maxHeight !== 'none') card.style.maxHeight = (card.querySelector('.rep-proj__list-inner').scrollHeight + 24) + 'px';
    }
    function listGroupsFor(st) {
      var cfg = st.cfg, lists = st.items && st.items.lists;
      if (!lists) return [];
      var base = cfg.mode === 'custom' ? ((cfg.custom && cfg.custom.base) || 'detailed') : cfg.mode;
      var src = (base === 'highlevel' ? lists.highlevel : lists.detailed) || { groups: [] };
      var headers = (cfg.custom && cfg.custom.headers) || {}, names = (cfg.custom && cfg.custom.names) || {};
      var hidden = {};
      (cfg.hidden || []).forEach(function(k) { hidden[k] = true; });
      var groups = (src.groups || []).map(function(g) {
        return {
          key: g.key, stockTitle: g.stockTitle || g.title,
          title: (cfg.mode === 'custom' && headers[g.key]) ? headers[g.key] : g.title,
          lines: (g.lines || []).filter(function(ln) { return !hidden[ln.key] || st.showRemoved; }).map(function(ln) {
            return { key: ln.key, qtyLabel: ln.qtyLabel, stock: ln.stock || ln.text, url: ln.url, removed: !!hidden[ln.key],
              text: (cfg.mode === 'custom' && names[ln.key]) ? names[ln.key] : (ln.stock || ln.text) };
          })
        };
      }).filter(function(g) { return g.lines.length; });
      // Items added under an existing group: by brand in Detailed, by category in High-Level.
      var byKey = {};
      groups.forEach(function(g) { byKey[g.key] = g; });
      (cfg.extraLines || []).forEach(function(x) {
        var brand = String(x.brand || '').trim(), cat = String(x.category || '').trim();
        var gTitle, gKey;
        if (base === 'detailed') { gTitle = brand || 'Additional Items'; gKey = brand ? 'brand:' + brand.toLowerCase() : 'extra:additional'; }
        else { gTitle = cat || (brand ? guessCategory(x.text) : 'Additional Items'); gKey = gTitle === 'Additional Items' ? 'extra:additional' : 'cat:' + gTitle.toLowerCase().replace(/[^a-z]+/g, '-'); }
        var g = byKey[gKey];
        if (!g) { g = { key: gKey, stockTitle: gTitle, title: (cfg.mode === 'custom' && headers[gKey]) ? headers[gKey] : gTitle, lines: [] }; byKey[gKey] = g; groups.push(g); }
        g.lines.push({ key: 'x:' + x.id, xid: x.id, extra: true, product: !!x.product, qtyLabel: String(x.qty || ''), text: extraDisplayText(x, base), stock: '', url: (cfg.linkProducts && x.product && x.product.url) || '' });
      });
      // Custom categories, always last.
      (cfg.extraGroups || []).forEach(function(xg) {
        groups.push({ key: 'xg:' + xg.id, xgid: xg.id, extraGroup: true, title: String(xg.title || ''), stockTitle: String(xg.title || ''),
          lines: (xg.lines || []).map(function(x) { return { key: 'x:' + x.id, xid: x.id, extra: true, product: !!x.product, qtyLabel: String(x.qty || ''), text: extraDisplayText(x, base), stock: '', url: (cfg.linkProducts && x.product && x.product.url) || '' }; }) });
      });
      return groups;
    }
    function renderListPreview(key, focusId, focusGroupId) {
      var st = listCardState[key];
      var card = detailAssets.querySelector('.rep-proj__asset-card[data-asset-key="' + key + '"] .rep-proj__list-card');
      if (!st || !card) return;
      var pv = card.querySelector('.rep-proj__list-preview');
      var note = card.querySelector('.rep-proj__list-note');
      if (!st.items) { pv.innerHTML = ''; return; }
      if (!st.items.hasItems) {
        pv.innerHTML = '<div class="rep-proj__list-empty">This plan was saved before item lists existed, so there is nothing to count yet. ' +
          'Open it in the Gym Layout Designer, save it once, and come back. The page will print nothing until then.</div>';
        note.textContent = '';
        return;
      }
      var groups = listGroupsFor(st);
      var editable = true; // editing any word flips to Custom
      /* The preview shows 15 lines and a View all / Show less toggle (Ryan 2026-09-23: "the list
         itself is visually VERY long"). Hidden lines keep their words; the PDF prints them all. */
      var LIMIT = 15;
      var total = groups.reduce(function(n, g) { return n + g.lines.length; }, 0);
      var shown = 0;
      var html = '';
      if (!groups.length) html = '<div class="rep-proj__list-empty">Nothing has been placed on this plan yet.</div>';
      groups.forEach(function(g) {
        if (!st.showAll && shown >= LIMIT) return;
        if (g.extraGroup) {
          html += '<div class="rep-proj__list-group rep-proj__list-group--extra">' +
            '<div class="rep-proj__list-group-head">' +
              '<div class="rep-proj__list-group-title" contenteditable="true" spellcheck="false" data-xgroup="' + esc(g.xgid) + '" title="Your category — click to rename">' + esc(g.title) + '</div>' +
              '<button type="button" class="rep-proj__list-x" data-xgdel="' + esc(g.xgid) + '" title="Remove this category and its items">&times;</button>' +
            '</div>';
        } else {
          html += '<div class="rep-proj__list-group">' +
            '<div class="rep-proj__list-group-title" contenteditable="' + editable + '" spellcheck="false" data-group="' + esc(g.key) + '" title="Click to retype">' + esc(g.title) + '</div>';
        }
        g.lines.forEach(function(ln) {
          if (!st.showAll && shown >= LIMIT) return;
          shown++;
          if (ln.extra) {
            html += '<div class="rep-proj__list-line rep-proj__list-line--extra" title="Your item">' +
              '<span class="rep-proj__list-qty" contenteditable="true" spellcheck="false" data-xqty="' + esc(ln.xid) + '" title="Quantity">' + esc(ln.qtyLabel) + '</span>' +
              '<span class="rep-proj__list-name' + (ln.product ? ' rep-proj__list-name--product' : '') + (ln.url ? ' rep-proj__list-name--link' : '') + '" contenteditable="true" spellcheck="false" data-xtext="' + esc(ln.xid) + '" data-placeholder="Item name, or @ to pick a product" title="' + (ln.product ? 'A website product. Type to reword it.' : 'Item name. Type @ to pick a product from the website.') + '">' + esc(ln.text) + '</span>' +
              '<button type="button" class="rep-proj__list-x" data-xdel="' + esc(ln.xid) + '" title="Remove this item">&times;</button>' +
              '</div>';
          } else if (ln.removed) {
            html += '<div class="rep-proj__list-line rep-proj__list-line--removed" title="Removed from the list (still on the plan)">' +
              '<span class="rep-proj__list-qty">' + esc(ln.qtyLabel) + '</span>' +
              '<span class="rep-proj__list-name">' + esc(ln.text) + '</span>' +
              '<button type="button" class="rep-proj__list-x rep-proj__list-restore" data-xrestore="' + esc(ln.key) + '" title="Put it back on the list">&#8634;</button>' +
              '</div>';
          } else {
            html += '<div class="rep-proj__list-line">' +
              '<span class="rep-proj__list-qty">' + esc(ln.qtyLabel) + '</span>' +
              '<span class="rep-proj__list-name' + (ln.url ? ' rep-proj__list-name--link' : '') + '" contenteditable="' + editable + '" spellcheck="false" data-line="' + esc(ln.key) + '" title="Click to retype">' + esc(ln.text) + '</span>' +
              '<button type="button" class="rep-proj__list-x rep-proj__list-hide" data-xhide="' + esc(ln.key) + '" title="Remove from the list (the plan keeps it)">&times;</button>' +
              '</div>';
          }
        });
        // "+ Add item" under the group: carries the brand (Detailed) or category (High-Level) it sits under.
        var where = g.extraGroup ? ('data-xg="' + esc(g.xgid) + '"')
          : (g.key.indexOf('brand:') === 0 ? 'data-brand="' + esc(g.stockTitle) + '"' : (g.key.indexOf('cat:') === 0 ? 'data-category="' + esc(g.stockTitle) + '"' : ''));
        html += '<button type="button" class="rep-proj__list-add" ' + where + ' title="Add an item of your own under this heading">+ Add item</button>';
        html += '</div>';
      });
      if (total > LIMIT) html += '<div class="rep-proj__list-more"><button type="button" class="rep-proj__ver-open rep-proj__list-toggle">' + (st.showAll ? 'Show less' : 'View all (' + (total - LIMIT) + ' more)') + '</button></div>';
      var nHidden = (st.cfg.hidden || []).length;
      if (nHidden) html += '<div class="rep-proj__list-more rep-proj__list-removed-row">' + nHidden + ' item' + (nHidden === 1 ? '' : 's') + ' removed from this list (still on the plan) &middot; <button type="button" class="rep-proj__ver-open rep-proj__list-showremoved">' + (st.showRemoved ? 'Hide them' : 'Show them') + '</button></div>';
      pv.innerHTML = html;
      var toggle = pv.querySelector('.rep-proj__list-toggle');
      if (toggle) toggle.addEventListener('click', function() { st.showAll = !st.showAll; renderListPreview(key); });
      // The extras: add / remove / edit, none of which touches the mode.
      pv.querySelectorAll('.rep-proj__list-add').forEach(function(b) {
        b.addEventListener('click', function() { addExtraLine(key, { brand: b.dataset.brand || '', category: b.dataset.category || '', xg: b.dataset.xg || '' }); });
      });
      pv.querySelectorAll('[data-xdel]').forEach(function(b) { b.addEventListener('click', function() { removeExtra(key, b.dataset.xdel); }); });
      pv.querySelectorAll('[data-xhide]').forEach(function(b) { b.addEventListener('click', function() { hideStock(key, b.dataset.xhide); }); });
      pv.querySelectorAll('[data-xrestore]').forEach(function(b) { b.addEventListener('click', function() { restoreStock(key, b.dataset.xrestore); }); });
      var sr = pv.querySelector('.rep-proj__list-showremoved');
      if (sr) sr.addEventListener('click', function() { st.showRemoved = !st.showRemoved; if (st.showRemoved) st.showAll = true; renderListPreview(key); });
      pv.querySelectorAll('[data-xgdel]').forEach(function(b) { b.addEventListener('click', function() { removeExtraGroup(key, b.dataset.xgdel); }); });
      var onExtraEdit = function(elm) {
        var txt = elm.textContent.replace(/\s+/g, ' ').trim();
        if (elm.dataset.xgroup) {
          var g = (st.cfg.extraGroups || []).filter(function(x) { return x.id === elm.dataset.xgroup; })[0];
          if (g) g.title = txt.slice(0, 80);
        } else {
          var f = findExtra(st.cfg, elm.dataset.xqty || elm.dataset.xtext);
          if (!f) return;
          if (elm.dataset.xqty) f.item.qty = txt.slice(0, 24);
          else {
            if (f.item.product && txt.indexOf('@') !== -1) return; // mid-pick: the menu owns this text
            f.item.text = txt.slice(0, 160);
            // An item under a brand gets its High-Level category from its words, so it lands right there too.
            if (f.item.brand && !f.item.categoryPinned) f.item.category = guessCategory(f.item.text);
          }
        }
        saveListConfig(key, st.cfg);
      };
      pv.querySelectorAll('[data-xtext]').forEach(function(span) {
        attachMention(span, function(p) {
          var f = findExtra(st.cfg, span.dataset.xtext);
          if (!f) return;
          f.item.product = { title: p.t || '', vendor: p.v || '', url: p.u || '', handle: p.h || '' };
          f.item.text = ''; // formatted per mode from the product, until the rep rewords it
          /* The heading it was added under WINS (Ryan 2026-09-23: an "@ECORE Performance Beast Plus"
             picked under ECORE Athletic landed under a new "ECORE" group — the website's vendor is
             the short form). Only an item with no heading yet takes the product's vendor, and even
             then it joins an existing brand group whose name starts the same way. */
          if (!f.item.brand && p.v) {
            var pv = String(p.v).toLowerCase(), match = '';
            (((st.items && st.items.lists && st.items.lists.detailed) || {}).groups || []).forEach(function(g) {
              var t = String(g.stockTitle || g.title || ''), tl = t.toLowerCase();
              if (!match && (tl === pv || tl.indexOf(pv + ' ') === 0 || pv.indexOf(tl + ' ') === 0)) match = t;
            });
            f.item.brand = match || p.v;
          }
          f.item.category = guessCategory(p.t || '');
          saveListConfig(key, st.cfg, true);
          renderListPreview(key);
          var q = pv.querySelector('[data-xqty="' + f.item.id + '"]');
          if (q) { q.focus(); try { document.execCommand('selectAll', false, null); } catch (_e) {} }
        });
      });
      pv.querySelectorAll('[data-xqty],[data-xtext],[data-xgroup]').forEach(function(elm) {
        elm.addEventListener('keydown', function(e) { if (e.key === 'Enter') { e.preventDefault(); elm.blur(); } if (e.key === 'Escape') elm.blur(); });
        elm.addEventListener('input', function() { onExtraEdit(elm); });
      });
      if (focusId || focusGroupId) {
        var target = focusGroupId ? pv.querySelector('[data-xgroup="' + focusGroupId + '"]') : pv.querySelector('[data-xtext="' + focusId + '"]');
        if (target) { target.focus(); try { document.execCommand('selectAll', false, null); } catch (_e) {} }
      }
      var noteText = 'There are countless ways to lay out a training space, and this is one of the options we put together as a starting point. Think of it as a conversation opener rather than a final answer: once you have had a look, we would love to hear what you think, refine it together, and help bring your ideal space to life.';
      note.innerHTML = '<span class="rep-proj__list-note-label">Closing note on the page</span>' + esc(noteText);
      // Retyping: any edit → Custom (base = the mode you were in), stored by key, saved debounced.
      var onEdit = function(elm, kind) {
        var txt = elm.textContent.replace(/\s+/g, ' ').trim();
        if (st.cfg.mode !== 'custom') {
          st.cfg.custom = { base: st.cfg.mode === 'highlevel' ? 'highlevel' : 'detailed', headers: {}, names: {} };
          st.cfg.mode = 'custom';
          syncListModeButtons(card, 'custom');
        }
        var bucket = kind === 'group' ? st.cfg.custom.headers : st.cfg.custom.names;
        var k = kind === 'group' ? elm.dataset.group : elm.dataset.line;
        var stock = kind === 'group' ? (groups.filter(function(g) { return g.key === k; })[0] || {}).stockTitle
                                     : (groups.reduce(function(a, g) { return a.concat(g.lines); }, []).filter(function(l) { return l.key === k; })[0] || {}).stock;
        if (!txt || txt === stock) delete bucket[k]; else bucket[k] = txt.slice(0, kind === 'group' ? 80 : 160);
        saveListConfig(key, st.cfg);
      };
      pv.querySelectorAll('[data-line],[data-group]').forEach(function(elm) {
        var kind = elm.dataset.group ? 'group' : 'line';
        elm.addEventListener('keydown', function(e) { if (e.key === 'Enter') { e.preventDefault(); elm.blur(); } if (e.key === 'Escape') { elm.blur(); } });
        elm.addEventListener('input', function() { onEdit(elm, kind); });
        elm.addEventListener('blur', function() { elm.textContent = elm.textContent.replace(/\s+/g, ' ').trim() || (kind === 'group' ? (groups.filter(function(g) { return g.key === elm.dataset.group; })[0] || {}).stockTitle : (groups.reduce(function(a, g) { return a.concat(g.lines); }, []).filter(function(l) { return l.key === elm.dataset.line; })[0] || {}).stock) || ''; });
      });
      if (card.classList.contains('rep-proj__list-card--open') && card.style.maxHeight !== 'none') card.style.maxHeight = (card.querySelector('.rep-proj__list-inner').scrollHeight + 24) + 'px';
    }
    /* END CUSTOM_PROJECTASSEMBLY_BY_CLAUDE — equipment-list page */
    return { listConfigFor: listConfigFor, toggleListCard: toggleListCard };
  };
})();
